import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const DISMISS_KEY = "pb_pwa_install_dismissed_at";
const DISMISS_TTL = 14 * 24 * 60 * 60 * 1000; // 14 days

/**
 * "Add PowerBuilt to home screen" prompt.
 * Uses the standardised beforeinstallprompt event on Chrome/Edge/Android.
 * Silently no-ops on iOS Safari (no API exposed) — users use Share → Add to Home Screen.
 */
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissed = parseInt(localStorage.getItem(DISMISS_KEY) || "0", 10);
    if (Date.now() - dismissed < DISMISS_TTL) return;
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice.catch(() => {});
    setDeferred(null);
    setShow(false);
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
  };

  const dismiss = () => {
    setShow(false);
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-sm z-40 card-pb p-4 shadow-xl border-2 border-[#C9A356]/40" data-testid="install-prompt">
      <button onClick={dismiss} aria-label="Dismiss" className="absolute top-2 right-2 text-[#94A3B8] hover:text-[#0A2540]">
        <X className="w-4 h-4" />
      </button>
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-md bg-[#C9A356] text-white grid place-items-center shrink-0">
          <Download className="w-5 h-5" />
        </div>
        <div>
          <div className="font-medium text-[#0A2540] dark:text-white text-sm">Install PowerBuilt</div>
          <p className="text-xs text-[#475569] dark:text-slate-400 mt-1 leading-relaxed">
            Add to your home screen for faster access — and work even when the signal drops.
          </p>
          <button onClick={install} className="btn-accent text-xs py-1.5 px-3 mt-3" data-testid="install-confirm">
            Add to home screen
          </button>
        </div>
      </div>
    </div>
  );
}
